<div class="sam-form-row" *ngIf="!isFeatureUnavailable">
   <div class="k-form-field sam-form-control sam-form-control-full-width">
      <div kendoTooltip>
         <kendo-dropdownlist
            class="k-form-field sam-form-control"
            fxFlex="1 1 auto"
            [data]="audioDevices$ | async"
            textField="label"
            valueField="deviceId"
            [valuePrimitive]="true"
            [value]="selectedDeviceId$ | async"
            (selectionChange)="onSelectionChange($event)"
         >
            <ng-template kendoDropDownListValueTemplate kendoDropDownListItemTemplate let-dataItem>
               {{ dataItem?.label | translate }}
            </ng-template>
         </kendo-dropdownlist>

         <div class="side-control">
            <!-- Play/Stop Button for output devices -->
            <button
               *ngIf="deviceType == 'audiooutput' || deviceType == 'ringer'"
               kendoButton
               (click)="toggleDeviceTest()"
            >
               <fa-icon
                  [icon]="(isDeviceTestActive$ | async) ? playingTestSoundIcon : stoppedTestSoundIcon"
                  [class.test-sound-active]="isDeviceTestActive$ | async"
               ></fa-icon>
            </button>

            <!-- vu-meter for input devices -->
            <fa-icon
               *ngIf="deviceType == 'audioinput'"
               [icon]="microphoneIcon"
               [class.test-sound-active]="true"
               [style.opacity]="inputDeviceIconOpacity$ | async"
            ></fa-icon>
         </div>
      </div>
   </div>
</div>
<ng-container *ngIf="isFeatureUnavailable">
   {{ 'common.audio_settings.no_device_selection_available_by_browser' | translate }}
</ng-container>
